module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/dec3b0138e045c5ed6158e4024a58c50.png";